import * as Yup from 'yup'
import { FormField } from './index'
import { useTranslation } from 'gatsby-plugin-react-i18next'

interface ValidationRules {
    required?: boolean
    pattern?: string
    message?: string
    type?: string
}

const getFieldValidation = (field: FormField) => {
    const { i18n } = useTranslation()
    let validator: any = Yup.string().trim()

    // Handle required fields
    if (!field.optional) {
        if (i18n.language === 'ar') {
            validator = validator.required('مطلوب')
        } else {
            validator = validator.required('Required')
        }
    }

    // Handle email validation
    if (field.type === 'email') {
        if (i18n.language === 'ar') {
            validator = validator.email('يرجى إدخال عنوان بريد إلكتروني صالح')
        } else {
            validator = validator.email('Please enter a valid email address')
        }
    }

    // Handle phone validation
    if (field.type === 'tel') {
        if (i18n.language === 'ar') {
            validator = validator.matches(/^[0-9]+$/, 'يجب أن يحتوي على أرقام فقط')
        } else {
            validator = validator.matches(/^[0-9]+$/, 'Must contain only numbers')
        }
    }

    // Handle pattern validation if provided
    if (field.validation?.pattern) {
        if (i18n.language === 'ar') {
            validator = validator.matches(
                new RegExp(field.validation.pattern),
                field.validation.message_ar || 'يجب أن يكون تنسيق صالح'
            )
        } else {
            validator = validator.matches(
                new RegExp(field.validation.pattern),
                field.validation.message || 'Invalid format'
            )
        }
    }

    // Handle minimum length for textarea
    if (field.type === 'textarea') {
        if (i18n.language === 'ar') {
            validator = validator.min(10, 'يرجى توفير المزيد من التفاصيل')
        } else {
            validator = validator.min(10, 'Please provide more details')
        }
    }

    return validator
}

export const generateValidationSchema = (formFields: FormField[]) => {
    const schemaFields = formFields.reduce((acc, field) => {
        acc[field.name] = getFieldValidation(field)
        return acc
    }, {} as { [key: string]: any })

    return Yup.object().shape(schemaFields)
}
